module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "id": "sidebar-menu"
    }
  }, [_c('li', {
    class: 'pageLink ' + (_vm.active == 'carte' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/map"
    }
  }, [_c('i', {
    staticClass: "fa fa-map"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Carte")])])], 1), _vm._v(" "), _c('li', {
    class: 'pageLink ' + (_vm.active == 'rondes' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/rondes"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-signs"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Rondes")])])], 1), _vm._v(" "), _c('li', {
    class: 'pageLink ' + (_vm.active == 'agents' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/agents"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Agents")])])], 1), _vm._v(" "), _c('li', {
    class: 'pageLink ' + (_vm.active == 'anomalies' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/anomalies"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Événements")])])], 1), _vm._v(" "), _c('li', {
    class: 'pageLink ' + (_vm.active == 'administrators' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/administrateurs"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-secret"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Administrateurs")])])], 1), _vm._v(" "), _c('li', {
    class: 'pageLink ' + (_vm.active == 'reporting' ? 'active' : '')
  }, [_c('router-link', {
    attrs: {
      "to": "/reporting"
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Reporting")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "pageLink pageLink--bottom",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Déconnexion")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60fa1679!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 1824
// module chunks = 2